/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/

const lang = {
  /* 01.General */
  "general.copyright": "BitBute © 2023 All Rights Reserved.",

  "unauthorized.title": "Unauthorized Access Attempt",
  "unauthorized.detail":
    "You are not authorized to view the page you are trying to access.",

  /* 02.User Login, Logout, Register */
  "user.login-title": "Login",
  "user.register": "Register",
  "user.forgot-password": "Forgot Password",
  "user.email": "E-mail",
  "user.password": "Password",
  "user.forgot-password-question": "Forgot password?",
  "user.first-name": "First Name",
  "user.last-name": "Last Name",
  "user.fullname": "Full Name",
  "user.login-button": "LOGIN",
  "user.register-button": "REGISTER",
  "user.reset-password-button": "RESET",
  "user.buy": "BUY",
  "user.username": "Username",
  "user.reset-password": "Reset Password",
  "user.new-password": "New Password",
  "user.new-password-again": "Confirm New Password",

  /* 03.Menu */
  "menu.home": "Home",
  "menu.app": "Home",
  "menu.dashboard": "Dashboard",
  "menu.dashboards": "Dashboards",
  "menu.gogo": "Gogo",
  "menu.start": "Start",
  "menu.projects": "Projects",
  "menu.reports": "Reports",
  "menu.admin": "Admin",
  "menu.admin-dashboard": "Dashboard",
  "menu.admin-projects": "Projects",
  "menu.second-menu": "Second Menu",
  "menu.second": "Second",
  "menu.ui": "UI",
  "menu.charts": "Charts",
  "menu.chat": "Chat",
  "menu.survey": "Survey",
  "menu.todo": "Todo",
  "menu.search": "Search",
  "menu.docs": "Docs",
  "menu.blank-page": "Blank Page",

  /* 04.Error Page */
  "pages.error-title": "Ooops... looks like an error occurred!",
  "pages.error-code": "Error code",
  "pages.go-back-home": "GO BACK HOME",
  "pages.purchase": "SELECT",

  // 05. Project List Page
  "projects-list.title": "Your Stores",
  "projects-list.add-project-title": "New Store",
  "pages.prices.featurecomparison": "Feature Comparison",

  // 06. Add New Project Modal
  "add-project-modal.title": "Create New Store",
  "add-project-modal.project-type-label": "Select Store Type",
  "add-project-modal.project-name-label": "Store Name",
  "add-project-modal.website-name-label": "Store Name ",

  "add-project-modal.project-url-label": "Store URL",
  "add-project-modal.domain-url-label": "Store Domain",

  // 07. Button common labels
  "button.create": "Create",
  "button.save": "Save",
  "button.cancel": "Cancel",
  "button.edit": "Edit",
  "button.delete": "Delete",
  "button.archive": "Archive",
  "button.publish": "Publish",
  "button.unpublish": "Unpublish",
  "button.preview": "Preview",
  "button.upload-media": "New Media",
  "button.confirm": "Confirm",
  "button.select-media": "Select Media",
  "button.remove": "Remove",
  "button.connect-domain": "Connect Domain",
  "button.disconnect-domain": "Disconnect Domain",

  // 08. AR Card
  "ar-card.title": "AR Card Details",
  "ar-card.add-title": "Add AR Card Details",
  "ar-card.edit-title": "Edit AR Card Details",
  "ar-card.full-name-label": "Full Name",
  "ar-card.email-label": "Email",
  "ar-card.phone-label": "Phone Number",
  "ar-card.website-label": "Website URL",
  "ar-card.image-label": "Image Link",
  "ar-card.image-file-label": "Image File",
  "ar-card.video-label": "Video Link",
  "ar-card.video-file-label": "Video File",
  "ar-card.instagram-label": "Instagram",
  "ar-card.twitter-label": "Twitter",
  "ar-card.linkedIn-label": "LinkedIn",

  // 09. Product Visualization
  "pv.title": "Product Visualization Details",
  "pv.add-title": "Add Product Visualization Details",
  "pv.edit-title": "Edit Product Visualization Details",
  "pv.3d-model-label": "3D Model",
  "pv.usdz-model-label": "USDZ Model",
  "pv.skyBox-bg-image-label": "SkyBox Bg Image",
  "pv.poster-label": "Poster",
  "pv.ar-placement-label": "AR Placement",
  "pv.auto-rotate-label": "Auto Rotate",

  // 10. Project Types
  "project.ar-card": "AR Card",
  "project.product-visualizer": "Product Visualizer",
  "project.ecommerce": "Ecommerce",

  "wizard.prev": "Back",
  "wizard.next": "Next",

  "menu.media": "Media",
  "media-list.title": "Media List",
};

export default lang;
